export const home = {
  'Made for': 'Hecho para',
  'New releases': 'Nuevos lanzamientos',
  ALL: 'Todo',
  PODCASTS: 'Podcasts',
  'Made for you': 'Hecho para ti',
  you: 'para ti',
  'Liked Songs': 'Canciones gustadas',
  Artists: 'Artistas',
  MUSIC: 'Música',
  SONGS: 'Canciones',
  ALBUMS: 'Álbumes',
  PLAYLISTS: 'Playlists',
  ARTISTS: 'Artistas',
  TRACKS: 'Canciones',
  Preview: 'Vista previa',
  'Log In': 'Iniciar sesión',
  'Not now': 'Ahora no',
  Trending: 'Tendencias',
  'Your playlists': 'Tus playlists',
  'Featured Charts': 'Listas destacadas',
  'Start listening with a free Spotify account':
    'Empieza a escuchar con una cuenta gratuita de Spotify',
  'You’re logged out': 'No iniciaste sesión',
  'Log in to add this to your Liked Songs.': 'Inicia sesión para agregarlo a Tus me gusta.',
  'Create a playlist': 'Crea una playlist',
  'Log in to create and share playlists.': 'Inicia sesión para crear y compartir playlists.',
  [`Let's access your library`]: `Accede a tu biblioteca`,
  'Log In to access all the features of the app':
    'Inicia sesión para acceder a todas las funciones de la aplicación',
  'Your top mixes': 'Tus mixes más escuchados',
  'Recently played': 'Escuchado recientemente',
  'Featured playlists': '¡En tendencia!',
  'Popular playlists': 'Playlists populares',
};
